import { render } from "./long-insure-detail.vue?vue&type=template&id=11f2d4de&scoped=true&ts=true"
import script from "./long-insure-detail.vue?vue&type=script&lang=ts"
export * from "./long-insure-detail.vue?vue&type=script&lang=ts"

import "./long-insure-detail.vue?vue&type=style&index=0&id=11f2d4de&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f2d4de"]])

export default __exports__